// js/custom-element/feature/free-gift.js

class AutoFreeGift {
  constructor(giftVariantId) {
    this.giftVariantId = Number(giftVariantId);
    this.isAddingGift = false;

    if (!this.giftVariantId) { 
      return;
    }

    const delegateRoot = window.rootDelegate || document;

    // Listen for product add events
    if (delegateRoot?.on) {
      delegateRoot.on("variant:added", this.handleVariantAdded.bind(this));
    } else {
      document.addEventListener("variant:added", this.handleVariantAdded.bind(this));
    }
  }

  async handleVariantAdded(event) {

    if (this.isAddingGift) {
      return;
    }

    const variantData = event.detail?.variant;
    if (!variantData) {
      console.warn("[AutoFreeGift] variant:added missing variant data:", event.detail);
    }

    await this.addGift();
  }

  async addGift() {
    this.isAddingGift = true;
    try {

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: this.giftVariantId,
          quantity: 1,
          properties: { _is_added_by_wls_auto_gift: true },
        }),
      });


      if (!response.ok) {
        console.error("[AutoFreeGift] Failed to add gift. Response:", response);
        throw new Error(`Gift add failed: ${response.status}`);
      }

      const added = await response.json();

      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      if (window.rootDelegate) {
        window.rootDelegate.emit("cart:refresh", { cart, openMiniCart: true });
      } else {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
      }
    } catch (error) {
      console.error("[AutoFreeGift] Error adding gift:", error);
    } finally {
      setTimeout(() => (this.isAddingGift = false), 1000);
    }
  }
}

// Auto-init on load
(() => {
  const scriptEl = document.currentScript;
  const giftVariantId = scriptEl?.dataset?.giftVariant;

  if (giftVariantId) {
    new AutoFreeGift(giftVariantId);
  } else {
    console.warn("[AutoFreeGift] Missing data-gift-variant on script tag.");
  }
})();
